(() => {
  if (window.pgpBranchMediaInstalled) return;
  window.pgpBranchMediaInstalled = true;
  const seen = new WeakSet();
  const load = video => {
    if (video.dataset.pgpLoaded) return;
    video.dataset.pgpLoaded = 'true';
    if (video.dataset.pgpPoster) {
      video.poster = video.dataset.pgpPoster;
      delete video.dataset.pgpPoster;
    }
    video.querySelectorAll('source[data-pgp-src], img[data-pgp-src]').forEach(source => {
      source.src = source.dataset.pgpSrc;
      source.removeAttribute('data-pgp-src');
    });
    video.load();
    if (video.dataset.pgpAutoplay === 'true') {
      video.autoplay = true;
      const play = video.play();
      if (play && play.catch) play.catch(() => {});
    }
  };
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { load(entry.target); observer.unobserve(entry.target); }
      }), { rootMargin: '100px 0px' })
    : null;
  const scan = root => root.querySelectorAll('video[data-pgp-branch-video]').forEach(video => {
    if (seen.has(video)) return;
    seen.add(video);
    for (const event of ['pointerenter', 'touchstart', 'focus']) video.addEventListener(event, () => load(video), { once: true, passive: true });
    if (observer) observer.observe(video); else load(video);
  });
  scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video[data-pgp-branch-video]').forEach(video => observer?.unobserve(video)));
})();
